// hooks/useOrgDetails.js
import { useState, useEffect } from 'react';
import api from './api';

const useOrgDetails = (props) => {
    const [orgDetails, setOrgDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getOrg = () => {
            const path = '/api/appconfig';
            api.get(path)
                .then(res => {
                    setOrgDetails(res.data.data);
                    setIsLoading(false);
                })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                        console.log('User is not authenticated or token expired. Redirecting to login page.');
                        props.history.push('/login');
                    } else {
                        if (error.response.status === 404) {
                            console.error('Error fetching org details:', error);
                            setError("No organization found. Please contact support.");
                        } else {
                            setError(error.message);
                            console.error('Error fetching organization details:', error);
                        }
                    }
                    setIsLoading(false);
                });
        };

        getOrg();
    }, [props]);

    return { orgDetails, isLoading, error };
};

export default useOrgDetails;